import type { RegisterInitRequest } from "@/services/api";

export enum SignUpStep {
  UserDetails,
  PhoneVerification,
  Payment,
  CheckPayment,
  PinCode,
  ExceededRegistrationAttempts,
  SuccessPayment,
}

export const TOTAL_STEPS = Object.values(SignUpStep).length;

export interface SignUpState {
  currentStep: SignUpStep;
  userData: RegisterInitRequest;
  userDetailsErrorMessage: string;
  phoneNumberError: string;
  resendCoolDown: number;
  smsErrorCount: number;
  smsSentCount: number;
  showCaptcha: boolean;
}
